export default "__VITE_ASSET__Kkp1BLZH__"